import React from "react";
import FieldError from "../FieldError";

interface FloatingTextFieldProps {
  name: string;
  label: string;
  required?: boolean;
  type?: string;
  error?: any;
  inputProps?: any;
  info?: string | null;
  register?: any;
}

const FloatingTextField: React.FC<FloatingTextFieldProps> = ({
  name,
  label,
  required = false,
  type = "text",
  error,
  inputProps = {},
  info = null,
  register,
}) => {
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.value = e.target.value.trim();
    inputProps?.onChange?.({ target: { value: e.target.value } });
    inputProps?.onBlur?.(e);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    inputProps?.onChange?.(e);
  };

  return (
    <>
      <div
        className={`floating-field field-wrapper mb-16 ${
          error ? "error-field" : ""
        }`}
      >
        <input
          id={name}
          type={type}
          placeholder=" "
          className="common-field"
          {...(register ? register(name, { required }) : {})}
          {...inputProps}
          onBlur={handleBlur}
          onChange={handleChange}
          aria-describedby={`${name}-error`}
        />
        <label htmlFor={name} className="field-label" role="presentation">
          {label}{" "}
          {required && (
            <span className="req-text" aria-label="required">
              *
            </span>
          )}
        </label>
      </div>
      <FieldError error={error} info={info} id={`${name}-error`} />
    </>
  );
};

export default FloatingTextField;
